import React, { useState } from "react";
import "./TalkPage.css";

interface Post {
  id: number;
  title: string;
  location: string;
  petName: string;
  date: string;
  views: number;
  comments: number;
  likes: number;
  rank?: number;
}

const SAMPLE_POSTS: Post[] = [
  {
    id: 1,
    title: "오류동 산책 같이 해용",
    location: "서울시 오류동",
    petName: "똑똑이",
    date: "2025.05.30",
    views: 2334,
    comments: 6,
    likes: 6,
    rank: 1,
  },
  {
    id: 2,
    title: "오류동 산책 같이 해용",
    location: "서울시 오류동",
    petName: "똑똑이",
    date: "2025.05.30",
    views: 2334,
    comments: 6,
    likes: 6,
    rank: 2,
  },
  {
    id: 3,
    title: "오류동 산책 같이 해용",
    location: "서울시 오류동",
    petName: "똑똑이",
    date: "2025.05.30",
    views: 2334,
    comments: 6,
    likes: 6,
    rank: 3,
  },
];

const TalkPage: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState("펫밀리 TOP");

  const getRankIcon = (rank: number) => {
    return `/images/icons/talk-rank-${rank}.svg`;
  };

  return (
    <div className="talk-page">
      <div className="talk-header">펫톡</div>

      <div className="category-menu">
        <a
          href="#"
          className={`category-item ${
            activeCategory === "펫밀리 TOP" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("펫밀리 TOP")}
        >
          <img
            src="/images/icons/talk-category-top.png"
            alt="펫밀리 TOP"
            className="category-icon"
          />
          <span>펫밀리 TOP</span>
        </a>
        <a
          href="#"
          className={`category-item ${
            activeCategory === "함께해요" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("함께해요")}
        >
          <img
            src="/images/icons/talk-category-with.png"
            alt="함께해요"
            className="category-icon"
          />
          <span>함께해요</span>
        </a>
        <a
          href="#"
          className={`category-item ${
            activeCategory === "펫나눔터" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("펫나눔터")}
        >
          <img
            src="/images/icons/talk-category-donate.png"
            alt="펫나눔터"
            className="category-icon"
          />
          <span>펫나눔터</span>
        </a>
        <a
          href="#"
          className={`category-item ${
            activeCategory === "묻고 답해요" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("묻고 답해요")}
        >
          <img
            src="/images/icons/talk-category-qna.png"
            alt="묻고 답해요"
            className="category-icon"
          />
          <span>묻고 답해요</span>
        </a>
        <a
          href="#"
          className={`category-item ${
            activeCategory === "찾아주세요" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("찾아주세요")}
        >
          <img
            src="/images/icons/talk-category-find.png"
            alt="찾아주세요"
            className="category-icon"
          />
          <span>찾아주세요</span>
        </a>
        <a
          href="#"
          className={`category-item ${
            activeCategory === "기억의 정원" ? "active" : ""
          }`}
          onClick={() => setActiveCategory("기억의 정원")}
        >
          <img
            src="/images/icons/talk-category-memory.png"
            alt="기억의 정원"
            className="category-icon"
          />
          <span>기억의 정원</span>
        </a>
      </div>

      <div className="boards-container">
        <div className="banner-section">배너 영역</div>
        <div className="board-section">
          <div className="board-header">
            <div className="board-title">
              <img
                src="/images/icons/talk-category-with-small.png"
                alt="함께해요"
              />
              <span>함께해요</span>
            </div>
            <a href="#" className="board-more">
              <img src="/images/icons/arrow-right.svg" alt="더보기" />
            </a>
          </div>

          <div className="post-list">
            {SAMPLE_POSTS.map((post) => (
              <div key={post.id} className="post-item">
                <div className="post-title">
                  {post.rank && (
                    <img
                      src={getRankIcon(post.rank)}
                      alt={`${post.rank}위`}
                      className="post-badge"
                    />
                  )}
                  {post.title}
                </div>
                <div className="post-info">
                  <span>{post.location}</span>
                  <span>|</span>
                  <span>{post.petName}</span>
                </div>
                <div className="post-stats">
                  <span>{post.date}</span>
                  <div className="post-stats-item">
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-view-count.svg"
                        alt="views"
                      />
                      {post.views}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-like-count.svg"
                        alt="likes"
                      />
                      {post.likes}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-reply-count.svg"
                        alt="comments"
                      />
                      {post.comments}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="board-section">
          <div className="board-header">
            <div className="board-title">
              <img
                src="/images/icons/talk-category-find-small.png"
                alt="찾아주세요"
              />
              <span>찾아주세요</span>
            </div>
            <a href="#" className="board-more">
              <img src="/images/icons/arrow-right.svg" alt="더보기" />
            </a>
          </div>

          <div className="post-list">
            {SAMPLE_POSTS.map((post) => (
              <div key={post.id} className="post-item">
                <div className="post-title">
                  {post.rank && (
                    <img
                      src={getRankIcon(post.rank)}
                      alt={`${post.rank}위`}
                      className="post-badge"
                    />
                  )}
                  {post.title}
                </div>
                <div className="post-info">
                  <span>{post.location}</span>
                  <span>|</span>
                  <span>{post.petName}</span>
                </div>
                <div className="post-stats">
                  <span>{post.date}</span>
                  <div className="post-stats-item">
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-view-count.svg"
                        alt="views"
                      />
                      {post.views}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-like-count.svg"
                        alt="likes"
                      />
                      {post.likes}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-reply-count.svg"
                        alt="comments"
                      />
                      {post.comments}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="board-section">
          <div className="board-header">
            <div className="board-title">
              <img
                src="/images/icons/talk-category-qna-small.png"
                alt="묻고답해요"
              />
              <span>묻고답해요</span>
            </div>
            <a href="#" className="board-more">
              <img src="/images/icons/arrow-right.svg" alt="더보기" />
            </a>
          </div>

          <div className="post-list">
            {SAMPLE_POSTS.map((post) => (
              <div key={post.id} className="post-item">
                <div className="post-title">
                  {post.rank && (
                    <img
                      src={getRankIcon(post.rank)}
                      alt={`${post.rank}위`}
                      className="post-badge"
                    />
                  )}
                  {post.title}
                </div>
                <div className="post-info">
                  <span>{post.location}</span>
                  <span>|</span>
                  <span>{post.petName}</span>
                </div>
                <div className="post-stats">
                  <span>{post.date}</span>
                  <div className="post-stats-item">
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-view-count.svg"
                        alt="views"
                      />
                      {post.views}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-like-count.svg"
                        alt="likes"
                      />
                      {post.likes}
                    </span>
                    <span className="stat-item">
                      <img
                        src="/images/icons/talk-reply-count.svg"
                        alt="comments"
                      />
                      {post.comments}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button className="floating-button">
        <img src="/images/icons/add-plus.svg" alt="글쓰기" />
      </button>
    </div>
  );
};

export default TalkPage;
